import app from '../firebase';
import moment from 'moment';
import { getFirestore, collection, getDocs, addDoc, query, orderBy } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function Conversation() {
    
    const [messages, setMessages] = useState([]);
    const { conversationId } = useParams();
    const [message, setMessage] = useState();

    const getMessages = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), `conversations/${conversationId}/messages`), orderBy('date')))
            .then(results => results.forEach(result => x.push([result.id, result.data()])))
        setMessages(x);
    }

    const sendMessage = async () => {
        if (!message) return alert('Please enter any message!');

        let newMessage = {
            name: 'Alden Vallestero',
            message,
            date: new Date()
        };
        
        await addDoc(collection(getFirestore(app), `conversations/${conversationId}/messages`), newMessage);
        getMessages();
    }

    useEffect(() => {
        getMessages();
    });

    return(
        <>
            <div className="container-fluid bg-light p-4">
                <h4>Conversation with <span className="text-success fw-bold">Joe Kenneth San Juan</span></h4>
                <br />
                {
                    messages.map(i => (
                        <div className="d-block rounded-3 border p-4 mb-2">
                            <span className="d-block fw-bold">{i[1].name}</span>
                            <small className="d-block text-muted mb-2">{moment(i[1].date.toDate()).format('LLL')}</small>
                            <p>{i[1].message}</p>
                        </div>
                    ))
                }

                <textarea className="form-control mb-2" cols="30" rows="2" onChange={data => setMessage(data.target.value)}></textarea>
                <button className="btn btn-success w-100" onClick={sendMessage}>Send</button>
            </div>
        </>
    )
}